import React from 'react';
import InputField from '../../../Forms/Input/InputField';

interface BitcoinPaymentSectionProps {
  voucherCode: string;
  onVoucherChange: (value: string) => void;
}

const BitcoinPaymentSection: React.FC<BitcoinPaymentSectionProps> = ({
  voucherCode,
  onVoucherChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onVoucherChange(e.target.value);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <InputField
        label="Código de Transacción"
        name="bitcoinVoucher"
        iconKey="payment" // 👈 puedes cambiarlo si tienes un icono específico para Bitcoin
        type="text"
        placeholder="Ingrese el código de transacción Bitcoin"
        value={voucherCode}
        onChange={handleChange}
      />
    </div>
  );
};

export default BitcoinPaymentSection;
